/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import ReactTooltip from 'react-tooltip';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'COMPONENTS';

const fields = [
  'BPLS_SIGNATORY_ONE_NAME',
  'BPLS_SIGNATORY_ONE_DESIGNATION',
  'BPLS_SIGNATORY_ONE_SIGNATURE',
  'BPLS_SIGNATORY_TWO_NAME',
  'BPLS_SIGNATORY_TWO_DESIGNATION',
  'BPLS_SIGNATORY_TWO_SIGNATURE',
  'BPLS_SIGNATORY_THREE_NAME',
  'BPLS_SIGNATORY_THREE_DESIGNATION',
  'BPLS_SIGNATORY_THREE_SIGNATURE',
  'BPLS',
  'BPLS_NEW_E2E',
  'BPLS_SPECIFIC_REGION_FOR_ADDRESS_SETTINGS',
  'BPLS_SPECIFIC_PROVINCE_FOR_ADDRESS_SETTINGS',
  'BPLS_SPECIFIC_MUNICIPALITY_FOR_ADDRESS_SETTINGS',
  'BPLS_PINNED_LOCATION_LATITUDE',
  'BPLS_PINNED_LOCATION_LONGITUDE',

  'TERMS_AND_CONDITION',
  'PAYMENT_TYPE',
  'EGOVPAY_RECEIPT_SERIES',
  'CIVIL_REGISTRY_PROCESS_TYPE',
  'BPLS_MANUAL_PROCESSING',
  'DIGITAL_ISSUANCE',
  'EVERIFY',
  'BUSINESS_ADDRESS',
  'TEL_8_DIGITS',
  'VIEW_EOR',
  'FSIS_INTEGRATION',
];

const signatureFields = [
  {
    title: 'Signatory 1',
    nameKey: 'BPLS_SIGNATORY_ONE_NAME',
    designationKey: 'BPLS_SIGNATORY_ONE_DESIGNATION',
    signatureKey: 'BPLS_SIGNATORY_ONE_SIGNATURE',
  },
  {
    title: 'Signatory 2',
    nameKey: 'BPLS_SIGNATORY_TWO_NAME',
    designationKey: 'BPLS_SIGNATORY_TWO_DESIGNATION',
    signatureKey: 'BPLS_SIGNATORY_TWO_SIGNATURE',
  },
  {
    title: 'Signatory 3',
    nameKey: 'BPLS_SIGNATORY_THREE_NAME',
    designationKey: 'BPLS_SIGNATORY_THREE_DESIGNATION',
    signatureKey: 'BPLS_SIGNATORY_THREE_SIGNATURE',
  },
];

function Components({
  getList,
  createSelect,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
  createCheckbox,
  createInput,
  getCms,
}) {
  const [imageLoading, setImageLoading] = useState({});
  const [imageError, setImageError] = useState({});
  const previousImageSources = useRef({});
  const permissions = getJson('permissions');

  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id'),
    });
  }, [item]);

  useEffect(() => {
    if (formData?.CIVIL_REGISTRY_PROCESS_TYPE === 'MANUAL') {
      setFormData({
        ...formData,
        DIGITAL_ISSUANCE: false,
      });
    }
  }, [formData?.CIVIL_REGISTRY_PROCESS_TYPE]);

  const getImageSource = (key) => {
    const value = _.get(formData, key);
    const cdnUrl = _.get(formData, `${key}.cdnUrl`) || _.get(value, 'cdnUrl') || _.get(value, 'url');

    if (_.isString(cdnUrl) && cdnUrl.trim()) {
      return cdnUrl;
    }

    if (_.isString(value) && value.trim()) {
      return value;
    }

    return '';
  };

  useEffect(() => {
    const currentSources = signatureFields.reduce((acc, item) => {
      acc[item.signatureKey] = getImageSource(item.signatureKey);
      return acc;
    }, {});

    const changedFields = signatureFields
      .map(item => item.signatureKey)
      .filter(key => previousImageSources.current[key] !== currentSources[key]);

    previousImageSources.current = currentSources;

    if (!changedFields.length) {
      return;
    }

    setImageLoading(prev => {
      const nextState = { ...prev };
      changedFields.forEach(key => {
        nextState[key] = !!currentSources[key];
      });
      return nextState;
    });

    setImageError(prev => {
      const nextState = { ...prev };
      changedFields.forEach(key => {
        nextState[key] = false;
      });
      return nextState;
    });
  }, [formData]);

  const onChange = (e) => {
    if (e.target.name === 'MANUAL_PROCESSING') {
      return setFormData({
        ...formData,
        [e.target.name]: e.target.checked,
        DIGITAL_ISSUANCE: false
      });
    }

    return setFormData({
      ...formData,
      [e.target.name]: e.target.checked
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.get(formData, 'id')) {
      return update(
        _.get(formData, 'id'),
        {
          body: JSON.stringify(
            _.pick(formData, [...fields])
          ),
        },
        () => getCms()
      );
    }

    return create(
      {
        body: JSON.stringify(
          _.pick(formData, [...fields])
        ),
      },
      () => getCms()
    );
  };

  const onChangePhoto = key => value => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const renderToolTip = (fieldId = '', label = 'enter text here') => {
    return (
      <>
        <i
          className="fa fa-question-circle pl-2 my-auto text-warning"
          data-tip=""
          data-for={fieldId}
        />
        <ReactTooltip
          place="top"
          id={fieldId}
          type="dark"
          effect="float"
          delayShow={300}
        >
          <div className="">
            {label}
            {/* <img src="" alt="img" /> // todo later: add image here from cms */}
          </div>
        </ReactTooltip>
      </>
    );
  };

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body p-4 p-lg-5">
        <style>{`
          .signatory-field .form-label {
            display: block;
            white-space: normal;
            word-break: break-word;
            line-height: 1.2;
          }
        `}</style>
        <form onSubmit={handleOnSubmit}>
          {createHidden({ key: 'id' }, { placeholder: '' })}

          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
            <div>
              <h5 className="mb-1 font-weight-bold">Components Library</h5>
              <p className="mb-0 text-muted">Manage component toggles and BPLS signatories.</p>
            </div>
          </div>

          <div className="border rounded bg-white shadow-sm p-3 mb-3">
            <p className="font-weight-bold mb-3">Component Settings</p>
            <div className="table-responsive">
              <table className="table table-borderless table-sm mb-0">
                <thead className="table-header">
                  <tr>
                    <th style={{ width: '32%' }}>Setting</th>
                    <th style={{ width: '68%' }}>Control</th>
                  </tr>
                </thead>
                <tbody className="table-details">
                  <tr>
                    <td className="font-weight-bold">BPLS PINNED LOCATION LATITUDE</td>
                    <td>
                      {createInput(
                        {
                          key: 'BPLS_PINNED_LOCATION_LATITUDE',
                          label: '',
                        },
                        { className: 'd-flex align-items-center align-self-center mb-0' }
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold">BPLS PINNED LOCATION LONGITUDE</td>
                    <td>
                      {createInput(
                        {
                          key: 'BPLS_PINNED_LOCATION_LONGITUDE',
                          label: '',
                        },
                        { className: 'd-flex align-items-center align-self-center mb-0' }
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold">BPLS MANUAL PROCESSING</td>
                    <td>
                      {createCheckbox(
                        { key: 'BPLS_MANUAL_PROCESSING', label: '' },
                        { className: 'd-flex align-items-center align-self-center mb-0' }
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold">TEL 8 DIGITS</td>
                    <td>
                      {createCheckbox(
                        { key: 'TEL_8_DIGITS', label: '' },
                        { className: 'd-flex align-items-center align-self-center mb-0' }
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold">TERMS AND CONDITION</td>
                    <td>
                      {createCheckbox(
                        { key: 'TERMS_AND_CONDITION', label: '' },
                        { className: 'd-flex align-items-center align-self-center mb-0' }
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold">PAYMENT TYPE</td>
                    <td>
                      {createSelect(
                        { key: 'PAYMENT_TYPE', label: '' },
                        [
                          {
                            label: 'EGOVPAY',
                            value: 'EGOVPAY',
                          },
                          {
                            label: 'MANUAL PAYMENT',
                            value: 'MANUAL_PAYMENT',
                          },
                        ],
                        { required: true, type: 'text' }
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold">VIEW EOR</td>
                    <td>
                      {createCheckbox(
                        { key: 'VIEW_EOR', label: '' },
                        { className: 'd-flex align-items-center align-self-center mb-0' }
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold">EGOVPAY RECEIPT SERIES</td>
                    <td>
                      {createSelect(
                        { key: 'EGOVPAY_RECEIPT_SERIES', label: '' },
                        [
                          {
                            label: 'eReceipt',
                            value: 'eReceipt',
                          },
                          {
                            label: 'eLGU eOR',
                            value: 'eLGU eOR',
                          },
                        ],
                        { required: true, type: 'text' }
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold">CIVIL REGISTRY PROCESS TYPE</td>
                    <td>
                      {createSelect(
                        { key: 'CIVIL_REGISTRY_PROCESS_TYPE', label: '' },
                        [
                          {
                            label: 'MANUAL',
                            value: 'MANUAL',
                          },
                          {
                            label: 'DIGITAL',
                            value: 'DIGITAL',
                          },
                        ],
                        { required: true, type: 'text' }
                      )}
                    </td>
                  </tr>
                  {_.get(formData, 'CIVIL_REGISTRY_PROCESS_TYPE') === 'DIGITAL' ? (
                    <tr>
                      <td className="font-weight-bold">DIGITAL ISSUANCE</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <input
                            name="DIGITAL_ISSUANCE"
                            type="checkbox"
                            checked={!!_.get(formData, 'DIGITAL_ISSUANCE')}
                            onChange={onChange}
                            disabled={_.get(formData, 'CIVIL_REGISTRY_PROCESS_TYPE') === 'MANUAL'}
                          />
                        </div>
                      </td>
                    </tr>
                  ) : ''}
                  <tr>
                    <td className="font-weight-bold">EVERIFY</td>
                    <td>
                      {createCheckbox(
                        { key: 'EVERIFY', label: '' },
                        { className: 'd-flex align-items-center align-self-center mb-0' }
                      )}
                    </td>
                  </tr>
                  {Acl(permissions, ['MANAGE FSIS SETTINGS']) && (
                    <tr>
                      <td className="font-weight-bold">FSIS INTEGRATION</td>
                      <td>
                        {createCheckbox(
                          { key: 'FSIS_INTEGRATION', label: '' },
                          { className: 'd-flex align-items-center align-self-center mb-0' }
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="border rounded bg-white shadow-sm p-3 mb-3">
            <p className="font-weight-bold mb-3">BPLS Signatories</p>
            <div className="row">
              {signatureFields.map(({
                title,
                nameKey,
                designationKey,
                signatureKey,
              }) => {
                const imageSource = getImageSource(signatureKey);
                const hasImage = !!imageSource && !imageError[signatureKey];

                return (
                  <div key={signatureKey} className="col-12 col-lg-4 mb-3">
                    <div className="border rounded p-3 h-100 bg-light">
                      <p className="font-weight-bold mb-2">{title}</p>
                      <div className="mb-2 signatory-field">
                        {createInput(
                          {
                            key: nameKey,
                            label: nameKey,
                          },
                          { className: 'd-flex align-items-center align-self-center' }
                        )}
                      </div>
                      <div className="mb-3 signatory-field">
                        {createInput(
                          {
                            key: designationKey,
                            label: designationKey,
                          },
                          { className: 'd-flex align-items-center align-self-center' }
                        )}
                      </div>
                      <p className="form-label font-weight-bold m-0 mb-1 signatory-field">{signatureKey}</p>
                      <p className="mb-2 text-danger font-weight-bold">(.png type ONLY, Max: 5MB)</p>
                      <div
                        className="d-flex justify-content-center align-items-center position-relative border rounded bg-light p-2 overflow-hidden mb-2"
                        style={{ minHeight: 140 }}
                      >
                        {imageLoading[signatureKey] && hasImage && (
                          <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 3 }}>
                            <span className="fas fa-2x fa-spin fa-spinner text-info" />
                          </div>
                        )}
                        {!hasImage && (
                          <div
                            className="position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                            style={{ zIndex: 2 }}
                          >
                            <i className="far fa-image text-secondary mb-1" style={{ fontSize: 20 }} />
                            <span className="text-dark font-weight-bold" style={{ fontSize: 12, letterSpacing: 0.4 }}>
                              NO IMAGE
                            </span>
                          </div>
                        )}
                        <img
                          className="img-fluid"
                          style={{
                            width: '100%',
                            maxWidth: 160,
                            maxHeight: 120,
                            objectFit: 'contain',
                            opacity: imageLoading[signatureKey] && hasImage ? 0 : hasImage ? 1 : 0.55
                          }}
                          alt={signatureKey}
                          src={hasImage ? imageSource : ImagePlaceholder}
                          onLoad={() => setImageLoading(prev => ({ ...prev, [signatureKey]: false }))}
                          onError={() => {
                            setImageLoading(prev => ({ ...prev, [signatureKey]: false }));
                            setImageError(prev => ({ ...prev, [signatureKey]: true }));
                          }}
                        />
                      </div>
                      <FilePondSingleUpload onChange={onChangePhoto(signatureKey)} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="d-flex justify-content-center pt-2">
            <button
              // disabled={creating}
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary px-4 font-weight-bold"
            >
              <span className="font-weight-bold">
                {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
                Submit
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

Components.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  getCms: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Components);
